<template>
    <div class="_chat">
        <!-- Content -->
        <div v-show="!loading">
            <div class="content-msg" id="chat">
                <div class="item-msg" :id='`msg_${index}`' v-for="(item, index) in messages" :class="[{'comment-me': item.userType == $CONST.VIDEO.CHAT.USER_TYPE.ME}, {'comment-teacher': item.userType == $CONST.VIDEO.CHAT.USER_TYPE.TEACHER}, {'comment-not-me': item.userType == $CONST.VIDEO.CHAT.USER_TYPE.ORTHER}]" :key="index">
                    <div class="avatar">
                        <img :src="item.avatar" alt="avatar">
                    </div>
                    <div class="msg">
                        <div class="_name">{{item.name}}</div>
                        <div class="content">
                            <p>{{item.content}}</p>
                            <p>{{item.time}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Btn: sent -->
            <div class="btn-sent">
                <div class="content">
                    <input type="text" name="chat_message" @keyup.enter="handleSend()" v-model="message" placeholder="..."/>
                </div>
                <div class="commit" @click="handleSend()">
                    <img src="../../../static/images/send-xanh.png"/>
                </div>                
            </div>
        </div>

        <!-- Loading -->
        <loading class="loading--lesson" :showLoading="loading" />
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex"
    import loading from "@/components/loading/loading"

    export default {
        data() {
            return {
                messages: [],
                message: null,
                userID: null,
                languageType: null,
                show: true,
                loading: true
            };
        },
        props: {
            course: {
                type: Object,
                default: {},
            }
        },
        components: {
            loading, 
        },
        created() {
            this.init();
        },
        computed: {
            ...mapState({
                mobile: (state) => state.header.mobile,
                totalComment: (state) => state.header.totalComment
            }),
        },
        updated() {
            if (this.show) {
                // Scroll
                this.scrollToElement(`msg_${this.messages.length - 1}`);
            }
        },
        methods: {
            init: async function () {

                this.userID = window.sessionStorage.getItem("id");
                this.languageType = this.$lang();

                // Get data messages
                let messages =  await this.getMessages({courseMaterialId: this.course.activeID});

                // Set data
                this.messages = this.convert(messages);

                // Read messages
                let currentDatetime = new Date();
                let timeSeen = currentDatetime.getFullYear() + "-" + this.appendLeadingZeroes(currentDatetime.getMonth() + 1) + "-" + this.appendLeadingZeroes(currentDatetime.getDate()) + " " + this.appendLeadingZeroes(currentDatetime.getHours()) + ":" + this.appendLeadingZeroes(currentDatetime.getMinutes()) + ":" + this.appendLeadingZeroes(currentDatetime.getSeconds());
                await this.readMessage({userId: this.userID, courseId: this.course.id, lessonId: this.course.activeID, timeSeen: timeSeen});

                // Reget total message
                let total = await this.getNotifications({userId: this.userID, languageType: this.languageType});
                this.setTotalComment(total);

                // Disabled loading
                this.loading = false;
            },

            ...mapMutations("header", ["setTotalComment"]),

            getNotifications: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseCommentListNew", params)
                        .then((response) => {
                            resolve(response.data.length);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            convert: function (data) {
                const results = data.reduce((accumulator, value) => {
                    
                    let msg = {};
                    msg['content'] = value.commentContent;
                    msg['name'] = value.userType == this.$CONST.VIDEO.CHAT.USER_TYPE.ME ? null : value.name;
                    msg['time'] = value.updateDate;
                    msg['userType'] = value.userType;
                    msg['avatar'] = value.portraitPath != null ? value.portraitPath : "../../../static/images/profile.jpg";

                    accumulator.push(msg);
                    return accumulator;
                }, []);

                let messages = results.reverse();

                return messages;
            },

            // Scroll msg
            scrollToElement(id) {
                let element = document.getElementById(id);
                if (element == null) return;
                element.scrollIntoView();
            },

            getMessages: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseMaterialCommentList", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            handleSend: async function () {
                if (this.message == null || this.message == "" || !this.show) return;

                // Disable btn send
                this.show = false;

                // Save
                await this.send({courseMaterialId: this.course.activeID, commentContent: this.message, createBy: this.userID})
                .then( async (response) => {

                    // Reset msg
                    this.message = null;

                    // Get data messages
                    let messages =  await this.getMessages({courseMaterialId: this.course.activeID});

                    // Set data
                    this.messages = this.convert(messages);

                    // Enable btn send
                    this.show = true;
                });
            },

            appendLeadingZeroes: function (n) {
                if(n <= 9){
                    return "0" + n;
                }
                return n
            },

            send: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/insertCourseMaterialComment", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            readMessage: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getTimeSeenComment", params)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
                });
            },
        }
    };
</script>

<style scoped>
    .content input {
        position: relative;
        width: 100% !important;
        line-height: 30px;
        font-size: 18px !important;
        font-weight: 500;
        color: #4b4b4b;
        border: none!important;
        outline: none!important;
        display: inline-block;
        height: 100% !important;
        padding-left: 5px;
    }
    .content {
        width: 80%;
        height: 100%;
    }
    .commit {
        width: 20%;
        height: 100%;
        display: flex;
        cursor: pointer;
    }
    .commit img {
        width: 40px;
        height: 40px;
        margin: auto;
    }
    .avatar img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .msg ._name {
        width: 100%;
        height: 15px;
        padding-left: 5px;
        font-size: 12px;
        font-weight: 700;
        color: #000;
    }
    .msg .content {
        border-radius: 10px;
        width: 100%;
        height: calc(100% - 15px);
        background-color: #01c3ff;
        padding: 5px 5px 0 0;
    }
    .msg .content .time {
        color: #ff5353;
    }
    .msg .content p {
        padding-left: 5px;
        padding-top: 0;
        padding-right: 0;
        padding-bottom: 0;
        font-size: 12px;
        font-weight: 700;
        color: #fff;
        margin: 0;
        line-height: 1.5;
        word-break: break-all;
    }
    .item-msg.comment-me .msg .content {
        background-color: #5ecd4e;
    }
    .item-msg.comment-teacher .msg .content {
        background-color: gray;
    }
    .item-msg.comment-me .avatar {
        display: flex;
        justify-content: flex-end;
    }
    .item-msg.comment-me:after {
        content: "";
        position: absolute;
        top: 22px;
        right: 13%;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 10px solid #5ecd4e;
    }
    .item-msg.comment-not-me:before {
        content: "";
        position: absolute;
        top: 22px;
        left: 13%;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: 10px solid #01c3ff;
    }
    .item-msg.comment-teacher:before {
        content: "";
        position: absolute;
        top: 22px;
        left: 40px;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: 10px solid gray;
    }
    .avatar {
        width: 15%;
        padding-top: 15px;
    }
    .item-msg {
        width: 100%;
        min-height: 60px;
        display: flex;
        margin-bottom: 10px;
        position: relative;
    }
    .item-msg.comment-me {
        flex-direction: row-reverse;
    }
    .msg {
        max-width: 85%;
        min-width: 65%;
    }
    .content-msg {
        width: 100%;
        padding: 5px;
        max-height: calc(100vh - 250px) !important;
        overflow: auto;
        transition: ease 0.5s;
    }
    .btn-sent {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 60px;
        z-index: 2;
        border-top: 1px solid gray;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    ._chat {
        position: relative;
        height: 100%;
        width: 100%;
    }
    .loading {
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: rgb(38 50 56 / 0%);
        transform: translate(-50%, -50%);
    }
    /* Scroll */
    #chat::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
        border-radius: 10px;
    }

    #chat::-webkit-scrollbar {
        width: 5px;
        background-color: #ffffff;
        border-radius: 0 10px 10px 0;
    }

    #chat::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    } 
</style>



// WEBPACK FOOTER //
// src/components/learn/chat.vue